import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.css";

const values = [
  { title: "Integrity", description: "Transparent guidance and ethical practices in every recommendation." },
  { title: "Customer first", description: "We shortlist options around your profile, not a product push." },
  { title: "Clarity", description: "Plain language on eligibility, documents, rates, and next steps." },
  { title: "Trust", description: "Long-term relationships built on reliable coordination with lenders." },
];

const reasons = [
  { title: "Expert guidance", description: "Specialists help you navigate lender criteria and paperwork." },
  { title: "Wide network", description: "Access to multiple banks and NBFCs for competitive options." },
  { title: "Structured process", description: "From enquiry to lender decision with clear handoffs." },
  { title: "Flexible solutions", description: "Personal, home, business, and vehicle finance facilitation." },
];

const AboutUs = () => {
  return (
    <main className="about-page">
      <section className="about-hero">
        <div className="about-hero-inner cb-rise">
          <span className="cb-section-label">About</span>
          <h1>Core Bankers</h1>
          <p>
            A brand of VedhaNirvana Private Limited. We are an RBI-compliant Direct Selling Agent
            helping individuals and businesses evaluate loan options across partner lenders.
          </p>
        </div>
      </section>

      <section className="about-section cb-container">
        <span className="cb-section-label">Mission</span>
        <h2 className="cb-section-title">Simplify access to the right loan partner</h2>
        <p className="about-lead">
          We do not lend. We facilitate conversations with banks and NBFCs so you understand fit,
          documentation, and estimated terms before you apply.
        </p>
      </section>

      <section className="about-section about-muted">
        <div className="cb-container">
          <span className="cb-section-label">Values</span>
          <h2 className="cb-section-title">How we work</h2>
          <div className="about-grid">
            {values.map((value) => (
              <article key={value.title} className="about-item">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-section cb-container">
        <span className="cb-section-label">Why us</span>
        <h2 className="cb-section-title">What clients come to us for</h2>
        <div className="about-grid">
          {reasons.map((reason) => (
            <article key={reason.title} className="about-item">
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </article>
          ))}
        </div>
        <div className="about-cta-row">
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
          <Link to="/contact" className="about-text-link">
            Contact the team
          </Link>
        </div>
        <p className="disclaimer">
          Disclaimer: Core Bankers is a Direct Selling Agent under VedhaNirvana Pvt Ltd, facilitating
          loan services from various banks and NBFCs. Loan approvals and terms are subject to lender policies.
        </p>
      </section>
    </main>
  );
};

export default AboutUs;
